var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.29,
    height: 180.286,
    viewBox: "0 0 180.29 180.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b6b6b6;}.b{fill:#161615;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.701 8.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-638.018,246.134-658.547,169.5l-1.182-4.4-1.854-6.927-1.182-4.4-1.855-6.927-1.182-4.4-3.532-13.194a16.531,16.531,0,0,0-1.458-3.639,16.34,16.34,0,0,0-3.488-4.4,16.618,16.618,0,0,0-11.082-4.255,16.549,16.549,0,0,0-4.286.566l-13.766,3.689-16.419,4.4-30.492,8.171-5.525,1.484-13.753,3.683a16.461,16.461,0,0,0-10.07,7.725,16.484,16.484,0,0,0-1.659,12.59l24.306,90.716,7.009,26.155a16.409,16.409,0,0,0,1.69,4.06,16.461,16.461,0,0,0,6.041,6.016,16.5,16.5,0,0,0,12.584,1.659l13.766-3.69,16.419-4.4,49.769-13.339A16.608,16.608,0,0,0-638.018,246.134Zm-131.014-89.9,87.529-23.458,1.138,4.255-87.529,23.452Zm2.936,10.937,87.523-23.452,1.138,4.249-87.523,23.452Zm5.859,21.881,71.066-19.04,1.138,4.25L-759.094,193.3ZM-757.3,200l80.828-21.661,1.138,4.256-80.828,21.654Zm4.067,15.193-1.138-4.256,61.2-16.393,1.138,4.249Zm40.341,50.75-1.137-4.249,37.626-10.083,1.143,4.25Zm-49.135-83.575-1.138-4.249,87.529-23.453,1.138,4.25Z",
    transform: "translate(781.904 -116.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-611.549,324.857l-33.9,9.083h29.242a16.493,16.493,0,0,0,11.144-4.319,16.516,16.516,0,0,0,5.443-12.269v-1A20.882,20.882,0,0,1-611.549,324.857Z",
    transform: "translate(744.844 -171.115)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-555.532,166.429l-21.29,79.451V188.988l1.986.535,1.137-4.249-3.124-.836v-7.178l4.922,1.32,1.138-4.249-6.06-1.622v-7.172l7.851,2.106,1.137-4.255-8.988-2.407V149.357a20.826,20.826,0,0,0-.886-6.041l10.447,2.8a16.462,16.462,0,0,1,10.07,7.725A16.486,16.486,0,0,1-555.532,166.429Z",
    transform: "translate(726.447 -124.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-593.437,145.427v91.935l-17.317-64.63h4.652v-4.4h-5.827l-1.86-6.927h7.687v-4.4h-8.863l-1.861-6.927H-606.1v-4.4H-618l-3.841-14.331a21.366,21.366,0,0,0-.842-2.5h12.66a16.483,16.483,0,0,1,9.805,3.218,16.645,16.645,0,0,1,5,5.9A16.468,16.468,0,0,1-593.437,145.427Z",
    transform: "translate(738.662 -120.189)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.379 8.655)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-596.26,138.842v121a20.9,20.9,0,0,1-5.928,14.608,21.045,21.045,0,0,1-7.718,5.054,20.785,20.785,0,0,1-7.342,1.326h-45.659l16.418-4.4h29.241a16.5,16.5,0,0,0,11.145-4.318,16.521,16.521,0,0,0,5.444-12.269v-1a20.946,20.946,0,0,0,2.91-17.2l-2.91-10.862V138.842a16.469,16.469,0,0,0-1.78-7.461,16.625,16.625,0,0,0-5-5.9,16.472,16.472,0,0,0-9.8-3.218h-12.66a20.591,20.591,0,0,0-2.457-4.4h15.117a20.986,20.986,0,0,1,17.713,9.737,20.787,20.787,0,0,1,2.389,5.2A20.831,20.831,0,0,1-596.26,138.842Z",
    transform: "translate(662.907 -117.86)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.683 21.233)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-599.276,147.01v4.4H-610l-1.175-4.4Z",
    transform: "translate(611.174 -147.01)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.036 11.327)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-598.143,162.56v4.4h-7.687l-1.176-4.4Z",
    transform: "translate(607.006 -162.56)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.072 22.654)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-597.011,178.111v4.4h-4.652l-1.175-4.4Z",
    transform: "translate(602.838 -178.111)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-630.329,238.412l-2.911-10.862-17.317-64.629-1.175-4.4-1.861-6.926-1.175-4.4-1.86-6.927-1.176-4.4-3.841-14.331a21.51,21.51,0,0,0-.842-2.5,20.556,20.556,0,0,0-2.458-4.4,21.026,21.026,0,0,0-22.409-7.939l-29.631,7.939-16.5,4.425h-.019l-6.563,1.76-9.573,2.565-17.663,4.733a20.834,20.834,0,0,0-12.741,9.78,20.851,20.851,0,0,0-2.1,15.928L-750.827,270.7a20.849,20.849,0,0,0,9.782,12.741,20.847,20.847,0,0,0,10.459,2.822,21.146,21.146,0,0,0,5.469-.723l29.63-7.939,16.419-4.4,33.9-9.082a20.886,20.886,0,0,0,11.93-8.505A20.95,20.95,0,0,0-630.329,238.412Zm-15.979,21.453L-696.078,273.2l-16.419,4.4-13.766,3.69a16.5,16.5,0,0,1-12.584-1.66,16.452,16.452,0,0,1-6.041-6.015,16.387,16.387,0,0,1-1.69-4.061l-7.009-26.154-24.306-90.716a16.486,16.486,0,0,1,1.66-12.59,16.458,16.458,0,0,1,10.07-7.726l13.752-3.684,5.526-1.483,30.491-8.171,16.419-4.4,13.765-3.689a16.516,16.516,0,0,1,4.287-.566,16.615,16.615,0,0,1,11.082,4.255,16.378,16.378,0,0,1,3.489,4.4,16.472,16.472,0,0,1,1.458,3.639l3.534,13.194,1.181,4.4,1.855,6.927,1.182,4.4,1.855,6.926,1.182,4.4,20.529,76.629A16.609,16.609,0,0,1-646.307,259.865Z",
    transform: "translate(782.866 -105.978)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.274 20.212)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 90.614,
    height: 4.4,
    transform: "translate(0 23.461) rotate(-15.006)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.932 10.941)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 90.614,
    height: 4.4,
    transform: "translate(0 23.461) rotate(-15.006)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.863 21.882)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 90.614,
    height: 4.4,
    transform: "translate(0 23.461) rotate(-15.006)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.795 37.235)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 73.57,
    height: 4.4,
    transform: "translate(0 19.048) rotate(-15.006)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.726 45.558)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 83.68,
    height: 4.4,
    transform: "translate(0 21.666) rotate(-15.006)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.658 61.759)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 63.359,
    height: 4.4,
    transform: "translate(0 16.405) rotate(-15.006)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.996 118.831)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 38.958,
    height: 4.4,
    transform: "translate(0 10.087) rotate(-15.006)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.752 18.391)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-547.092,160.682-572.631,256V239l21.29-79.452a16.486,16.486,0,0,0-1.66-12.59,16.46,16.46,0,0,0-10.07-7.725l-10.446-2.8a20.811,20.811,0,0,0-2.389-5.2l13.973,3.746a20.853,20.853,0,0,1,12.741,9.78A20.849,20.849,0,0,1-547.092,160.682Z",
    transform: "translate(575.906 -131.227)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.275 22.868)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-562.422,165.028l-1.138,4.256-7.851-2.106v-4.557Z",
    transform: "translate(571.41 -162.621)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.729)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-565.35,180.345l-1.138,4.249-4.922-1.32v-4.551Z",
    transform: "translate(571.41 -178.723)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.458)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-568.286,195.662l-1.138,4.249-1.986-.534v-4.551Z",
    transform: "translate(571.41 -194.826)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.46aadb12bd640ef04cdeef2148845fd5.svg";
export { ForwardRef as ReactComponent };